import { render, staticRenderFns } from "./CustomerReturns.vue?vue&type=template&id=2b539b7c&scoped=true"
import script from "./CustomerReturns.vue?vue&type=script&lang=js"
export * from "./CustomerReturns.vue?vue&type=script&lang=js"
import style0 from "./CustomerReturns.vue?vue&type=style&index=0&id=2b539b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b539b7c",
  null
  
)

export default component.exports